require('./RARadialMenu.scss');

const React = require('react');
const PropTypes = require('prop-types');
const classNames = require('classnames');

class RARadialMenu extends React.Component {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }

    getRadialItemClass(selectedValue, id) {
        const customClass = classNames('robo-radial-menu__petal', {
            ['robo-radial-menu__petal--selected']: selectedValue === id,
            ['robo-radial-menu__petal--selected-hover']: !this.props.disabled,
        });

        return customClass;
    }

    handleClick(e) {
        if (this.props.disabled) {
            return;
        }

        this.props.onRadialItemClick(e.currentTarget.dataset.id);
    }

    render() {
        const {
            selectedValue,
            title,
            subtitle,
            values,
            titleTooltip,
        } = this.props;
        const buildCapitalClassName = this.getRadialItemClass(
            selectedValue,
            values[0].id,
        );
        const investCapitalClassName = this.getRadialItemClass(
            selectedValue,
            values[1].id,
        );
        const preserveCapitalClassName = this.getRadialItemClass(
            selectedValue,
            values[2].id,
        );
        const increaseCapitalClassName = this.getRadialItemClass(
            selectedValue,
            values[3].id,
        );

        return (
            <div className="robo-radial-menu">
                <div className="robo-radial-menu__title">
                    {title} {titleTooltip}
                </div>
                <div className="robo-radial-menu__subtitle">{subtitle}</div>
                <div className="robo-radial-menu__stem">
                    <ul className="robo-radial-menu__flower">
                        <li
                            className={investCapitalClassName}
                            onClick={this.handleClick}
                            data-id={values[1].id}
                        >
                            <span className="robo-radial-menu__petal__icon icon-conservar-patrimonio" />
                            <span className="robo-radial-menu__petal__text">
                                {values[1].label.title}
                            </span>
                        </li>
                        <li
                            className={preserveCapitalClassName}
                            onClick={this.handleClick}
                            data-id={values[2].id}
                        >
                            <span className="robo-radial-menu__petal__icon icon-incremento-moderado" />
                            <span className="robo-radial-menu__petal__text">
                                {values[2].label.title}
                            </span>
                        </li>
                        <li
                            className={increaseCapitalClassName}
                            onClick={this.handleClick}
                            data-id={values[3].id}
                        >
                            <span className="robo-radial-menu__petal__icon icon-incremento-significativo" />
                            <span className="robo-radial-menu__petal__text">
                                {values[3].label.title}
                            </span>
                        </li>
                        <li
                            className={buildCapitalClassName}
                            onClick={this.handleClick}
                            data-id={values[0].id}
                        >
                            <span className="robo-radial-menu__petal__icon icon-depositos" />
                            <span className="robo-radial-menu__petal__text">
                                {values[0].label.title}
                            </span>
                        </li>
                    </ul>
                    <div className="robo-radial-menu__stigma" />
                </div>
            </div>
        );
    }
}

RARadialMenu.propTypes = {
    onRadialItemClick: PropTypes.func.isRequired,
    selectedValue: PropTypes.string.isRequired,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
    subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    disabled: PropTypes.bool,
    values: PropTypes.array,
    titleTooltip: PropTypes.any,
};

module.exports = RARadialMenu;
